import React, { useEffect, useState } from "react";
import {
  ModalContainer,
  ModalListContainer,
  ModalListHeader,
  ModalItem,
  SubHeader,
  SwitchLogType,
  SwitchButton,
} from "./styles";
import { TbCalendar } from "react-icons/tb";
import { AiOutlineEye, AiOutlineUser } from "react-icons/ai";
import Divider from "@components/Divider/Divider";
import { datetimeHelper } from "@helpers/datetime";

import cpfIcon from "@assets/cpfIcon.svg";

import Modal from "react-modal";
import ModalDetailsAdmin from "@components/Modal/ModalDetailsAdmin/ModalDetailsAdmin";
import ModalHeader from "@components/Modal/ModalHeader/ModalHeader";
import { RemoveHistoryClient } from "@domain/models/RemoveHistoryClient";
import { GetRemoveHistoryClientsUseCase } from "@useCases/index";
import { HttpRemoveRepository } from "@data/repositories/index";
import { api } from "@data/api";
import { RemoveHistory } from "@domain/models/RemoveHistory";
import Loading from "@components/Loading/Loading";
import { Timestamp } from "firebase/firestore";

type Props = {
  history: RemoveHistory;
  onClose: () => void;
};

export default function ModalViewClients({ history, onClose }: Props) {
  const [loading, setLoading] = useState(true);

  const [switchSelected, setSwitchSelected] = useState<RemoveHistoryClient["status"]>("removed");

  const [modalDetails, setModalDetails] = useState({ clientId: "", visible: false });

  const [modalData, setModalData] = useState<RemoveHistoryClient[]>([]);

  const filterBySwitch = (type: "removed" | "notRemoved") => {
    return modalData.filter((x) => x.status === type);
  };

  useEffect(() => {
    const useCase = new GetRemoveHistoryClientsUseCase(new HttpRemoveRepository(api));

    useCase
      .execute(history.id)
      .then((clients) => {
        setModalData(clients);
      })
      .finally(() => setLoading(false));
  }, [history]);

  if (loading) {
    return (
      <ModalContainer>
        <Loading />
      </ModalContainer>
    );
  }

  const tableData = filterBySwitch(switchSelected);

  return (
    <ModalContainer>
      <ModalHeader
        title={`Remoção de clientes ${datetimeHelper.getFullDate(history.createdAt)}`}
        onClose={onClose}
      />
      <SwitchLogType>
        <SwitchButton
          selected={switchSelected === "removed" ? true : false}
          onClick={() => setSwitchSelected("removed")}
        >
          Clientes removidos
          {switchSelected === "removed" && <div></div>}
        </SwitchButton>
        <SwitchButton
          selected={switchSelected === "notRemoved" ? true : false}
          onClick={() => setSwitchSelected("notRemoved")}
        >
          Clientes não removidos
          {switchSelected === "notRemoved" && <div></div>}
        </SwitchButton>
      </SwitchLogType>
      <SubHeader>
        <div>
          <h4>Retirada em:</h4>
          <TbCalendar />
          <h4>{datetimeHelper.getDate(history.createdAt)}</h4>
        </div>
        <div>
          <h4>Usuário:</h4>
          <AiOutlineUser />
          <h4>{history.userName}</h4>
        </div>
        {history.undo && (
          <>
            <div>
              <h4>Desfeita em:</h4>
              <TbCalendar />
              <h4>
                {datetimeHelper.getDate(Timestamp.fromMillis(history.undo.date["_seconds"] * 1000))}
              </h4>
            </div>
            <div>
              <h4>Usuário:</h4>
              <AiOutlineUser />
              <h4>{history.undo.userName}</h4>
            </div>
          </>
        )}
      </SubHeader>
      <ModalListHeader>
        <h3>Nome</h3>
        <h3>CPF</h3>
        <h3>Ações</h3>
      </ModalListHeader>
      <ModalListContainer>
        {tableData &&
          tableData.map((item, index) => (
            <div key={index}>
              <ModalItem key={index}>
                <h4>{item.name}</h4>
                <div>
                  <img src={cpfIcon} alt="cpf" />
                  <h4>{item.id}</h4>
                </div>
                <div>
                  <AiOutlineEye
                    onClick={() => {
                      setModalDetails({
                        clientId: item.id,
                        visible: true,
                      });
                    }}
                    cursor="pointer"
                    size={18}
                    color="#808B9F"
                    fill="#808B9F"
                    style={{ marginLeft: 10 }}
                  />
                </div>
              </ModalItem>
              {index < tableData.length && <Divider width="98%" />}
            </div>
          ))}
      </ModalListContainer>

      <Modal
        isOpen={modalDetails.visible}
        onRequestClose={() => setModalDetails({ clientId: "", visible: false })}
        overlayClassName="modal-overlay"
        className="modal-content-auto-width"
        contentLabel="Example Modal"
      >
        {modalDetails.clientId ? (
          <ModalDetailsAdmin
            clientId={modalDetails.clientId}
            onClose={() => setModalDetails({ clientId: "", visible: false })}
          />
        ) : (
          <></>
        )}
      </Modal>
    </ModalContainer>
  );
}
